import {
  anOutlierRule,
  aRulePage,
  aThresholdRule,
  mockRulesListQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import {
  OUTLIER_RULE_DATA,
  SHARED_RULE_DATA,
  THRESHOLD_RULE_DATA,
} from './RuleBuilderQueryOperation.mocks';

export const rulesListQuery_threshold = mockRulesListQueryOperationQuery(
  async ({ query: _query, variables: _variables }) => {
    await delay(1500);
    return HttpResponse.json({
      data: {
        __typename: 'Query',
        rules: aRulePage({
          hasNextPage: false,
          objects: [
            aThresholdRule({
              ...SHARED_RULE_DATA,
              name: THRESHOLD_RULE_DATA.updatedName,
              score: THRESHOLD_RULE_DATA.updatedScore,
            }),
          ],
          total: 1,
        }),
      },
    });
  }
);

export const rulesListQuery_outlier = mockRulesListQueryOperationQuery(
  async ({ query: _query, variables: _variables }) => {
    await delay(1500);
    return HttpResponse.json({
      data: {
        __typename: 'Query',
        rules: aRulePage({
          hasNextPage: false,
          objects: [
            anOutlierRule({
              ...SHARED_RULE_DATA,
              name: OUTLIER_RULE_DATA.updatedName,
              score: OUTLIER_RULE_DATA.updatedScore,
            }),
          ],
          total: 1,
        }),
      },
    });
  }
);

export const handlers = [
  mockRulesListQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          rules: aRulePage(),
        },
      });
    }
  ),
];
